import { TextField, type DialogProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { DialogValue } from "../../../../services/api/instances/dialogApi/types";
import type { StylistValue } from "../../../../services/api/instances/stylistApi/stylistTypes";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { TransferObjectModal } from "../../../Modals/TransferObjectModal";
import { FolderSelection } from "../../../Modals/TransferObjectModal/Components/FolderSelection";
import { getFilteredOption } from "../../../Modals/TransferObjectModal/helpers";
import { useTransferModal } from "../../../Modals/TransferObjectModal/hooks/use-transfer-modal";
import type { TransferActions } from "../../../Modals/TransferObjectModal/types";
import {
  deleteChildrenAction,
  updateStylistWithChildrenAction,
} from "../../redux/actions";
import { selectStylists } from "../../redux/selectors";
import { setSelectedStylistAction, setStylistAction } from "../../redux/slice";
import styles from "./styles.module.css";
import { StorageObject } from "../../../../services/api/instances/storageApi/types/object_types";

const actions: TransferActions<StylistValue> = {
  updateObjectWithChildren: updateStylistWithChildrenAction,
  deleteChild: deleteChildrenAction,
  setObjects: setStylistAction,
  setSelectedObject: setSelectedStylistAction,
};

interface Props extends DialogProps {
  closeModal: () => void;
  childId?: string;
}

export const StylistTransferModal: FC<Props> = ({
  childId,
  closeModal,
  ...props
}) => {
  const stylists = useAppSelector(selectStylists);
  const { handleTransfer, targetFolder, objects, handleSelectChange } =
    useTransferModal<StylistValue>(stylists, actions);
  const { t } = useTranslation();
  return (
    <TransferObjectModal
      closeModal={closeModal}
      onClose={closeModal}
      onOk={() => {
        closeModal();
        handleTransfer(childId as string);
      }}
      {...props}
    >
      <div className={styles.container}>
        <FolderSelection
          options={getFilteredOption(objects)}
          value={targetFolder}
          inputValue={targetFolder?.friendly_name}
          getOptionLabel={(option: StorageObject<DialogValue>) =>
            option.friendly_name
          }
          onChange={handleSelectChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={"outlined"}
              placeholder={t("transfer_modal.input_placeholder")}
            />
          )}
        />
      </div>
    </TransferObjectModal>
  );
};
